import React from 'react';

import { NavigationContainer } from '@react-navigation/native';
import { StyleSheet } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { Main, Social, Market, AppScreen } from './components';

const Stack = createNativeStackNavigator();

const App = () => {
    return (
        <NavigationContainer>
            <Stack.Navigator screenOptions={{ headerShown: false }}>
                <Stack.Screen name='Home' component={Main} />
                <Stack.Screen name='Socials' component={Social} />
                <Stack.Screen name='Markets' component={Market} />
                <Stack.Screen name='Marketplaces' component={AppScreen} />
            </Stack.Navigator>
        </NavigationContainer>
    )
}

export default App;
